import { Heading } from '@dittolive/anvil'
import React, { PropsWithChildren } from 'react'

type StatContainerProps = {
  label: string
}

export const StatContainer = ({
  label,
  children,
}: PropsWithChildren<StatContainerProps>) => (
  <div
    className="border-l-border-normal col-span-6 flex flex-col gap-y-1.5 border-l p-4 md:col-span-3"
    data-testid="collectionsStat"
  >
    <Heading
      level={3}
      className="text-foreground-subtle mb-0 text-base font-normal sm:text-base"
    >
      {label}
    </Heading>
    <div className="text-foreground-normal text-3xl font-medium">
      {children}
    </div>
  </div>
)
